module.exports = __webpack_public_path__ + "static/media/debtor-creditor-acc.74a8b7f5.svg";